import { Map } from 'immutable'
import { createSelector } from 'reselect'
import { createToJsSelector } from 'selectors/utils'
import { identity } from 'ramda'
import { getIn, getInOr, keys, safeToJS } from 'utils/immutable'

const selectedIdSelector = getIn(['navigator', 'selectedId'])

const componentMetaSelector = getIn(['navigator', 'componentMeta'])

const componentMetaByIdSelector = (state, { id }) =>
  getInOr(Map(), ['navigator', 'componentMeta', id], state)

const isEditingSelector = getIn(['navigator', 'isEditing'])

const isSimulatingSelector = getIn(['navigator', 'isSimulating'])

const hideBreadcrumbSelector = getIn(['navigator', 'hideBreadcrumb'])

const isFullscreenSelector = getIn(['navigator', 'isFullscreen'])
export const getIsFullscreen = createSelector(isFullscreenSelector, identity)

export const getSelectedId = createSelector(selectedIdSelector, identity)

export const getComponentMeta = createToJsSelector(
  componentMetaSelector,
  identity
)

export const makeComponentMetaSelector = () =>
  createToJsSelector(createSelector(componentMetaByIdSelector, identity))

export const getIsEditing = createSelector(isEditingSelector, identity)
export const getIsSimulating = createSelector(isSimulatingSelector, identity)

export const getHideBreadcrumb = createSelector(
  hideBreadcrumbSelector,
  identity
)

const componentMetaKeysSelector = createSelector(componentMetaSelector, keys)

export const getComponentMetaKeys = createSelector(
  componentMetaKeysSelector,
  safeToJS
)
